export default "__VITE_ASSET__Bj1ON8aS__"